"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutToolbarButtons = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var LayoutContext_1 = require("./LayoutContext");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var dynamic_1 = require("@vanilla-extract/dynamic");
var LayoutToolbarButtons = function (_a) {
    var _b;
    var _c = (0, LayoutContext_1.useLayoutContext)(), editMode = _c.editMode, setEditMode = _c.setEditMode;
    return (react_1.default.createElement(react_1.default.Fragment, null, editMode ? (react_1.default.createElement(kaleidoscope_1.Button, { key: "done", className: tokens_1.darkTheme, style: (0, dynamic_1.assignInlineVars)((_b = {},
            _b[tokens_1.tokens.color.surfaceHover] = tokens_1.palette.green700,
            _b[tokens_1.tokens.color.text] = tokens_1.palette.green400,
            _b[tokens_1.tokens.color.icon] = tokens_1.palette.green500,
            _b)), type: kaleidoscope_1.ButtonType.Tertiary, onClick: function () {
            setEditMode(false);
        } },
        react_1.default.createElement(icons_1.Tick, null),
        " Done")) : (react_1.default.createElement(kaleidoscope_1.Button, { key: "edit", className: tokens_1.darkTheme, type: kaleidoscope_1.ButtonType.Tertiary, onClick: function () {
            setEditMode(true);
        } },
        react_1.default.createElement(icons_1.Edit, null),
        " Edit layout"))));
};
exports.LayoutToolbarButtons = LayoutToolbarButtons;
